import { Module } from 'vuex';
import { RootState } from '@/store';
import { OfficesModel } from '@/models/Offices.model';
import { UnitsModel } from '@/models/Units.model';
import { Form101SearchModel } from '@/models/Form101Search.model';
import { getters } from '@/store/modules/manager/getters';
import { mutations } from '@/store/modules/manager/mutations';
import { actions } from '@/store/modules/manager/actions';
import { Grid } from '@/models/Grid.model';
import { Form101StatisticsModel } from '@/models/manager/Form101Statistics.model';
import { CodeTable } from '@/models/base/CodeTable.interface';
import { ManagerForm101Data } from '@/models/manager/ManagerForm101Data.model';
import { CubesInfoModel } from '@/models/manager/CubesInfo.model';
import { Document } from '@/models/form/Documents.model';
import { ApproveFormRequest } from '@/models/manager/ApproveFormRequest';
import { GetIdNumberFieldsResponseModel } from '@/models/manager/GetIdNumberFieldsResponse.model';
import { FormsSearchFilters } from '@/models/manager/forms-search-filters';
import { CubesStatsModel } from '@/models/manager/CubesStats.model';
import { subscribeToResult } from 'rxjs/internal-compatibility';

export interface ManagerState {
  managerMode: boolean;
  managerLoading: boolean;
  offices: OfficesModel[];
  units: UnitsModel[];
  form101UnitsListLoading: boolean;
  form101SearchObject: Form101SearchModel;
  formsSearchFilters: FormsSearchFilters[];
  formsResultData: Grid;
  formsSearchErrors: string[];
  statistics: Form101StatisticsModel[];
  statisticsErrors: any;
  statisticsOffices: OfficesModel[];
  formStatusHistory: Grid;
  form101Changes: any;
  form101SectionNames: any;
  form101SectionNotes: object;
  approveFormErrors: string[];
  rejectFormErrors: string[];
  form101ChangesNotesErrors: string[];
  form101StatusesList: CodeTable[];
  searchEmployeesCurrentForm: ManagerForm101Data;
  employeeEmail: string;
  openManagerFormResetPasswordModal: boolean;
  openManagerFormResetPasswordModalErrors: string[];
  openRemoveFormModal: boolean;
  openRemoveFormModalErrors: string[];
  cubesInfo: CubesInfoModel[];
  cubesInfoErrors: string[];
  cubeDetails: Grid;
  cubeDetailsErrors: string[];
  maskitMode: boolean;
  adpMode: boolean;
  manualForms: Document[];
  openApproveFormsModal: boolean;
  openApproveFormsModalErrors: string[];
  selectedFormsToApprove: ApproveFormRequest[];
  idNumberFields: GetIdNumberFieldsResponseModel;
  canApprove: boolean;
  canReject: boolean;
  statusDesc: string;
  openManualFormModal: boolean;
  form101RejectReason: string;
  form101Filters: any[];
  cube: CubesInfoModel;
  resetPasswordLoading: boolean;
  cubesStats: CubesStatsModel;
  cubesStatsLoading: boolean;
  cubesStatsErrors: string[];
  openManualUpdateIptModal: boolean;
  manualUpdateIptModalErrors: string[];
  cubeSearchObject: Form101SearchModel;
}

export const initialState = ((): ManagerState => {
  return {
    managerMode: false,
    managerLoading: false,
    offices: [],
    units: [],
    form101UnitsListLoading: false,
    form101SearchObject: {
      taxYear: new Date().getFullYear(),
    },
    formsSearchFilters: [],
    formsResultData: {} as Grid,
    formsSearchErrors: [],
    statistics: [],
    statisticsErrors: {},
    statisticsOffices: [],
    formStatusHistory: {} as Grid,
    form101Changes: {},
    form101SectionNames: {},
    form101SectionNotes: {},
    approveFormErrors: [],
    rejectFormErrors: [],
    form101ChangesNotesErrors: [],
    form101StatusesList: [],
    searchEmployeesCurrentForm: {} as ManagerForm101Data,
    employeeEmail: '',
    openManagerFormResetPasswordModal: false,
    openManagerFormResetPasswordModalErrors: [],
    openRemoveFormModal: false,
    openRemoveFormModalErrors: [],
    cubesInfo: [],
    cubesInfoErrors: [],
    cubeDetails: {} as Grid,
    cubeDetailsErrors: [],
    maskitMode: false,
    adpMode: false,
    openApproveFormsModal: false,
    openApproveFormsModalErrors: [],
    selectedFormsToApprove: [],
    manualForms: [],
    idNumberFields: {} as GetIdNumberFieldsResponseModel,
    canApprove: false,
    canReject: false,
    openManualFormModal: false,
    statusDesc: '',
    form101RejectReason: '',
    form101Filters: [],
    cube: {} as CubesInfoModel,
    resetPasswordLoading: false,
    cubesStats: {} as CubesStatsModel,
    cubesStatsLoading: false,
    cubesStatsErrors: [],
    openManualUpdateIptModal: false,
    manualUpdateIptModalErrors: [],
    cubeSearchObject: {} as Form101SearchModel,
  };
});
export const manager: Module<ManagerState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
